import { AfterViewInit, Component, ElementRef, HostListener, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatStepper } from '@angular/material/stepper';
import { Router } from '@angular/router';
import { faSquareXmark } from '@fortawesome/free-solid-svg-icons';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectComponent } from '@ng-select/ng-select';
import { fadeIn, fadeInOut, fadeOut } from 'src/app/animations';
import { IFormGuard } from 'src/app/shared/interface/IFormGuard';
import { ModalDadosBancariosPDVComponent } from 'src/app/shared/modals/modal-dados-bancarios-pdv/modal-dados-bancarios-pdv.component';
import { ModalValidacaoPlanoSaudeInstitutoComponent } from 'src/app/shared/modals/modal-validacao-plano-saude-instituto/modal-validacao-plano-saude-instituto.component';
import { TokenService } from 'src/app/shared/services/token.service';
import { UsuarioService } from 'src/app/shared/services/usuario.service';
import { FormValidator } from 'src/app/shared/validators/Validator';
import Swal from 'sweetalert2';
import { BeneficioService } from '../../services/previdencia/beneficio.service';
import { SocialSecurityService } from '../../services/previdencia/social-security.service';
import { AceitesService } from '../../services/saude/aceites.service';
import { HealthService } from '../../services/saude/health.service';
import { SolicitationService } from '../../services/usuario/solicitation.service';
@Component({
  selector: 'app-pdv',
  templateUrl: './pdv.component.html',
  styleUrls: ['./pdv.component.css'],
  animations: [fadeIn, fadeOut, fadeInOut]
})
export class PdvComponent implements AfterViewInit, IFormGuard, OnInit {
  @ViewChild('containerSelect') containerSelect!: ElementRef;
  @ViewChild('ngSelect') ngSelect!: NgSelectComponent;
  @ViewChild('stepper') stepper!: MatStepper;
  faSquareXmark = faSquareXmark;
  initialValueForm: any;
  formChanged: boolean = false;
  healthProfile: any;
  socialSecurityProfile: any;
  loadAfterRequired: boolean = false;
  dataBanco: any;
  user: any;
  planoSelecionado: any;
  listDependentePrevidenciario: any;
  planId: any;
  base: any;
  loading: boolean = false;
  loadingCosts: boolean = false;
  parceladoBoolean: boolean = false;
  beneficiaries!: any[];
  beneficiariesSaude!: any[];
  listaValores: any[] = [];
  listaDocumentos: any[] = [];
  listaDependentesIr: any[] = [];
  listaDocumentoRg: any[] = [];
  listaDocumentoCpc: any[] = [];
  listaDocumentosRescisaoContrato: any[] = [];
  listaDocumentosBsa: any[] = [];
  listaEmailsInvalidos: any[] = ['fcopel', 'copel', 'uega', 'lactec', 'compagas', 'tradener'];
  reserva: any;
  aceiteMeusDados: boolean = false;
  aceiteDadosBancarios: boolean = false;
  aceiteDependentesIr: boolean = false;
  aceiteInstituto: boolean = false;
  aceiteInstitutoSelecionado: boolean = false;
  aceiteProSaude: boolean = false;
  aceiteRevisao: boolean = false;
  aceiteFinalizar: boolean = false;
  formFinalizado: boolean = false;
  beneficioRisco: string = '';
  mediaSalarial: string = '';
  resgateReserva: any = {};
  taxaAdministrativa: string = '';
  empresaPatrocinadora: any = null;
  valorInstitutoParcial: any;
  AdditionalContribution: number = 0;
  ContributionHistory: number = 0;
  canceladoCapitalizacao: boolean = false
  possuiPeculio: boolean = false;
  statusAposentadoriaFile: boolean = false;
  // form: FormGroup = this._formBuilder.group({
  //   dependentesIr
  // });
  listaDependentes: any = [
    { familyType: 'Marido', name: 'Gustavo de Oliveira Achinitz', cpf: '11111111111' },
    { familyType: 'Filho', name: 'Criança 1', cpf: '22222222222' },
    { familyType: 'Filho', name: 'Criança 2', cpf: '33333333333' },
  ]
  meusDados: FormGroup = this._formBuilder.group({
    cpf: new FormControl({ value: null, disabled: true }),
    name: new FormControl({ value: null, disabled: true }),
    registration: new FormControl({ value: null, disabled: true }),
  });
  formContact: FormGroup = new FormGroup({
    aceitesContato: new FormControl(false, [Validators.requiredTrue]),
    address: new FormControl(null, [Validators.required]),
    cep: new FormControl(null, [Validators.required]),
    city: new FormControl(null, [Validators.required]),
    comercialPhone: new FormControl(''),
    complement: new FormControl(null),
    country: new FormControl(null, [Validators.required]),
    district: new FormControl(null, [Validators.required]),
    email: new FormControl(null, [Validators.required, Validators.pattern('^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\\.[a-zA-Z0-9-.]+$'), FormValidator.validEmailPdv(this.listaEmailsInvalidos)]),
    number: new FormControl(null, [Validators.required]),
    personalPhone: new FormControl(null, [Validators.required]),
    postalCode: new FormControl(null),
    replicateDependant: new FormControl(false),
    registration: new FormControl(null),
    secondaryEmail: new FormControl(null, [Validators.pattern('^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\\.[a-zA-Z0-9-.]+$'), FormValidator.validEmailPdv(this.listaEmailsInvalidos)]),
    state: new FormControl(null, [Validators.required])
  });
  formDadosBancarios = this._formBuilder.group({
    aceitesDadosBancarios: new FormControl(false, [Validators.requiredTrue]),
    documentos: this.createDocument(false, 'Dados Bancarios'),
  });
  formDependentesIr: FormGroup = new FormGroup({
    aceitesIr: new FormControl(false, [Validators.requiredTrue]),
  });
  formInstituido: FormGroup = new FormGroup({
    aceiteInstituido: new FormControl(false, [Validators.requiredTrue]),
    instituido: new FormControl(null, [Validators.required]),
  });
  formDocumentos = this._formBuilder.group({
    aceite: new FormControl(false, [Validators.requiredTrue]),
    actualHealth: new FormControl(),
    actualSocialSecurity: new FormControl(),
    adicionalBeneficio: new FormControl(),
    // contribuicaoeOuAportes:  new FormControl(),
    contribuicaoNormalMensal: new FormControl(),
    documentoRg: this.createDocument(false, 'Documento RG'),
    documentoCpf: this.createDocument(false, 'Documento CPF'),
    documentoRescisao: this.createDocument(false, 'Documento Rescisao'),
    documentoBsa: this.createDocument(false, 'Documento BSA'),
    id: new FormControl(null),
    interessePermanencia: new FormControl(),
    portabilidadeOuResgateParcial: new FormControl(),
    quantidadeParcelas: new FormControl(),
    solicitationId: new FormControl(),
    tributacao: new FormControl(),
    valorSolicitadoPortabilidadeParcial: new FormControl(),
  });
  formSaude = this._formBuilder.group({
    aceite: new FormControl(false, [Validators.requiredTrue]),
  });
  profile: any;
  secondFormGroup: FormGroup = this._formBuilder.group({ secondCtrl: [''] });
  constructor(private _formBuilder: FormBuilder, private aceitesService: AceitesService, private modalService: NgbModal, private userService: UsuarioService
    , private tokenService: TokenService, private socialSecurityService: SocialSecurityService, private healthService: HealthService, private solicitationService: SolicitationService, private beneficioService: BeneficioService, private router: Router) {
    this.userService.getProfiles().subscribe({
      next: (res: any) => {
        this.profile = res
      },
      error: (err: any) => {
      }
    });
    this.socialSecurityService.getResgateReserva().subscribe((res: any) => { this.reserva = res; });
    this.formContact.markAllAsTouched();
    this.formContact.get('address')?.disable();
    this.formContact.get('district')?.disable();
    this.formContact.get('state')?.disable();
    this.formContact.get('country')?.disable();
    this.formContact.get('city')?.disable();
    this.beneficioService.getBase().subscribe({
      next: (res: any) => {
        this.mediaSalarial = res.plano?.contribuicaoMinima;
        this.beneficioRisco = res.plano?.beneficioRiscoDuasPartes;
        this.taxaAdministrativa = res.plano?.taxaAdministrativaDuasPartes;
        this.possuiPeculio = (res?.plano?.peculioCobertura != 0) ? true : false;
        this.dataBanco = res.contaAtiva;
        this.base = res;
        this.loading = true;
        this.resgateReserva = res.resgateReserva;
        this.listDependentePrevidenciario = res.dependentesPrevidencia.filter(
          (item: any) => {
            return item.situacao.toUpperCase() != 'FALECIDO'
          }
        )
        // this.listDependentePrevidenciario = res.dependentesPrevidencia.reduce( (acc: any, current:any) => {
        //   if (!acc.find( (item:any) => item.name === current.name)) {
        //     acc.push(current);
        //   }
        //   return acc;
        // }, [] );
        this.beneficiaries = res.dependentesSaude.reduce((acc: any, current: any) => {
          if (!acc.find((item: any) => item.name === current.name)) {
            acc.push(current);
          }
          return acc;
        }, []);
        this.AdditionalContribution = parseFloat(res.plano?.aportes);
        this.ContributionHistory = parseFloat(res.plano?.contribuicaoFacultativa);
        this.canceladoCapitalizacao = res.canceladoCapitalizacao;
        // this.formContact.get('cep')?.setValue(res.address.cep);
        // this.formContact.updateValueAndValidity();
        // this.formContact.get('address')?.setValue(res.address.endereco);
        // this.formContact.get('city')?.setValue(res.address.complemento);
        // this.formContact.get('comercialPhone')?.setValue(res.pessoa.phonefixo);
        // this.formContact.get('complement')?.setValue(res.address.complemento);
        // this.formContact.get('country')?.setValue(res.address.complemento);
        // this.formContact.get('district')?.setValue(res.address.complemento);
        // this.formContact.get('email')?.setValue(res.pessoa.email);
        // this.formContact.get('secondaryEmail')?.setValue(res.pessoa.email2);
        // this.formContact.get('personalPhone')?.setValue(res.pessoa.phone);
        // this.formContact.get('state')?.setValue(res.address.uf);
        // this.formContact.get('number')?.setValue(res.address.numero);
        // aceitesContato: new FormControl(false, [Validators.requiredTrue]),
        // address: new FormControl(null, [Validators.required]),
        // cep: new FormControl(null, [Validators.required]),
        // city: new FormControl(null, [Validators.required]),
        // comercialPhone: new FormControl(null),
        // complement: new FormControl(null),
        // country: new FormControl(null, [Validators.required]),
        // district: new FormControl(null, [Validators.required]),
        // email: new FormControl(null, [Validators.required, Validators.pattern('^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\\.[a-zA-Z0-9-.]+$'), FormValidator.validEmailPdv(this.listaEmailsInvalidos)]),
        // number: new FormControl(null, [Validators.required]),
        // personalPhone: new FormControl(null, [Validators.required]),
        // postalCode: new FormControl(null),
        // replicateDependant: new FormControl(false),
        // registration: new FormControl(null),
        // secondaryEmail: new FormControl(null, [Validators.pattern('^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\\.[a-zA-Z0-9-.]+$'), FormValidator.validEmailPdv(this.listaEmailsInvalidos)]),
        // state: new FormControl(null, [Validators.required])
        // this.listDependentePrevidenciario = res.dependentes.reduce( (acc: any, current:any) => {
        //   if (!acc.find( (item:any) => item.nome === current.nome)) {
        //     acc.push(current);
        //   }
        //   return acc;
        // }, [] );
      }
    })
    this.initComboBox();
    this.user = this.tokenService.getActiveUser();
    this.socialSecurityService.getPersonData().subscribe({
      next: (personData: any) => {
        if (personData) {
          this.planId = personData.personData?.adesoes[0].planId;
          this.planoSelecionado = personData.adesoes[0];
        }
      }
    });
    // this.socialSecurityService.getDependentes().subscribe({
    //   next: (res: any) => {
    //     this.listDependentePrevidenciario = res.reduce( (acc: any, current:any) => {
    //          if (!acc.find( (item:any) => item.name === current.name)) {
    //            acc.push(current);
    //          }
    //          return acc;
    //        }, [] );     
    //   }
    // });
    // this.healthService.getBeneficiaryAndHealthData().subscribe({
    //   next: (res: any) => {
    //     this.beneficiaries = res.reduce( (acc: any, current:any) => {
    //       if (!acc.find( (item:any) => item.name === current.name)) {
    //         acc.push(current);
    //       }
    //       return acc;
    //     }, [] );
    //     this.empresaPatrocinadora = res[0].company;   
    //   },
    //   error: (res: any) => { }
    // });
    this.userService.getUser(this.user.cpf).subscribe({
      next: (res: any) => {
        this.formContact.patchValue(res.contactResponse);
        setTimeout(() => {
          this.initialValueForm = this.formContact.getRawValue();
        }, 300)
        this.meusDados.patchValue(res.userDataResponse);
      }
    });
    //   this.userService.getBeneficiaries().subscribe({
    //     next: (res: any) => {
    //     this.beneficiaries = res;      
    //   }
    // });
    this.aceitesService.GetActualBankAccount().subscribe({
      next: (data: any) => {
        // this.dataBanco = data;        
      },
      error: (err: any) => {
      }
    });
  }
  detectChange(): boolean {
    if (this.formFinalizado == true || (!this.formContact.dirty && !this.formDocumentos.dirty)) {
      return false;
    }
    if (this.formContact.dirty && this.formDocumentos.dirty) {
      return true;
    }
    return true;
  }
  resetValor(tipo: string) {
    // if(this.formDocumentos.get('quantidadeParcelas')?.value == null || this.formDocumentos.get('quantidadeParcelas')?.value == ''){
    //   this.formDocumentos.get('quantidadeParcelas')?.reset();
    // }     
    if (tipo == 'parcelaUnica') {
      this.parceladoBoolean = false;
      this.ngSelect.handleClearClick();
      this.formDocumentos.get('quantidadeParcelas')?.setValue('1');
    } else if (tipo == 'parcelado') {
      if (this.formDocumentos.get('quantidadeParcelas')?.value != null) {
        this.formDocumentos.get('quantidadeParcelas')?.reset();
      }
      setTimeout(() => {
        this.ngSelect.changeEvent.subscribe((event: any) => {
          this.parceladoBoolean = true;
          this.formDocumentos.get('quantidadeParcelas')?.setValue(event.value);
        })
      }, 1100);
    }
  }
  removeDuplicates(arr: any): any[] {
    let unique_array = []
    for (let i = 0; i < arr.length; i++) {
      if (unique_array.indexOf(arr[i]) == -1) {
        unique_array.push(arr[i])
      }
    }
    return unique_array;
  }
  showValues() {
  }
  changeQuantidadeParcelas(event: any) {
    this.formDocumentos.get('quantidadeParcelas')?.setValue(JSON.stringify(event.label));
    this.parceladoBoolean = true;
    this.formDocumentos.updateValueAndValidity();
    document.getElementById('permanecer-form-false')?.click();
  }
  cepChanged() {
    if (this.formContact.get('cep')?.value.length == 8) {
      // this.formContact.get('number')?.patchValue(null);
      // this.formContact.get('complement')?.patchValue(null);
      this.solicitationService.getZipCodeParams(this.formContact.get('cep')?.value)
        .subscribe((res: any) => {
          if (res.localidade) {
            if (res.logradouro) {
              this.formContact.get('address')?.setValue(res.logradouro.toUpperCase());
              this.formContact.get('address')?.disable();
            } else {
              this.formContact.get('address')?.setValue(null);
              this.formContact.get('address')?.enable();
            }
            this.formContact.get('city')?.setValue(res.localidade.toUpperCase());
            this.formContact.get('city')?.disable();
            this.formContact.get('state')?.setValue(res.uf.toUpperCase());
            this.formContact.get('state')?.disable();
            if (res.bairro) {
              this.formContact.get('district')?.setValue(res.bairro.toUpperCase());
              this.formContact.get('district')?.disable();
            } else {
              this.formContact.get('district')?.setValue(null);
              this.formContact.get('district')?.enable();
            }
            this.formContact.get('country')?.setValue('BRASIL');
            this.formContact.get('country')?.disable();
            this.formContact.updateValueAndValidity();
          } else {
            this.formContact.get('cep')?.setErrors({ 'incorrect': true });
            this.formContact.get('address')?.setValue(null);
            this.formContact.get('address')?.enable();
            this.formContact.get('city')?.setValue(null);
            // this.formContact.get('city')?.enable();
            this.formContact.get('state')?.setValue(null);
            // this.formContact.get('state')?.enable();
            this.formContact.get('district')?.setValue(null);
            this.formContact.get('district')?.enable();
            this.formContact.get('country')?.setValue('BRASIL');
            // this.formContact.get('country')?.enable();
          }
        });
    } else {
      this.formContact.get('address')?.setValue(null);
      this.formContact.get('address')?.enable();
      this.formContact.get('address')?.updateValueAndValidity();
      this.formContact.get('city')?.setValue(null);
      this.formContact.get('city')?.enable();
      this.formContact.get('city')?.updateValueAndValidity();
      this.formContact.get('state')?.setValue(null);
      this.formContact.get('state')?.enable();
      this.formContact.get('state')?.updateValueAndValidity();
      this.formContact.get('district')?.setValue(null);
      this.formContact.get('district')?.enable();
      this.formContact.get('district')?.updateValueAndValidity();
      this.formContact.get('country')?.setValue('BRASIL');
      this.formContact.get('country')?.enable();
      this.formContact.get('country')?.updateValueAndValidity();
    }
  }
  inputChanged() {
    if (this.formContact.get('cep')?.value.length == 8) {
      this.solicitationService.getZipCodeParams(this.formContact.get('cep')?.value)
        .subscribe((res: any) => {
          if (res.localidade) {
            if (res.logradouro) {
              this.formContact.get('address')?.setValue(res.logradouro.toUpperCase());
              this.formContact.get('address')?.disable();
            } else {
              this.formContact.get('address')?.setValue(null);
              this.formContact.get('address')?.enable();
            }
            this.formContact.get('city')?.setValue(res.localidade.toUpperCase());
            this.formContact.get('city')?.disable();
            this.formContact.get('state')?.setValue(res.uf.toUpperCase());
            this.formContact.get('state')?.disable();
            if (res.bairro) {
              this.formContact.get('district')?.setValue(res.bairro.toUpperCase());
              this.formContact.get('district')?.disable();
            } else {
              this.formContact.get('district')?.setValue(null);
              this.formContact.get('district')?.enable();
            }
            this.formContact.get('country')?.setValue('BRASIL');
            this.formContact.get('country')?.disable();
            this.formContact.updateValueAndValidity();
          } else {
            this.formContact.get('cep')?.setErrors({ 'incorrect': true });
            this.formContact.get('address')?.setValue(null);
            this.formContact.get('address')?.enable();
            this.formContact.get('address')?.updateValueAndValidity();
            this.formContact.get('city')?.setValue(null);
            this.formContact.get('city')?.enable();
            this.formContact.get('city')?.updateValueAndValidity();
            this.formContact.get('state')?.setValue(null);
            this.formContact.get('state')?.enable();
            this.formContact.get('state')?.updateValueAndValidity();
            this.formContact.get('district')?.setValue(null);
            this.formContact.get('district')?.enable();
            this.formContact.get('district')?.updateValueAndValidity();
            this.formContact.get('country')?.setValue('BRASIL');
            this.formContact.get('country')?.enable();
            this.formContact.get('country')?.updateValueAndValidity();
          }
        });
    } else {
      this.formContact.get('address')?.setValue(null);
      this.formContact.get('address')?.enable();
      this.formContact.get('address')?.updateValueAndValidity();
      this.formContact.get('city')?.setValue(null);
      this.formContact.get('city')?.enable();
      this.formContact.get('city')?.updateValueAndValidity();
      this.formContact.get('state')?.setValue(null);
      this.formContact.get('state')?.enable();
      this.formContact.get('state')?.updateValueAndValidity();
      this.formContact.get('district')?.setValue(null);
      this.formContact.get('district')?.enable();
      this.formContact.get('district')?.updateValueAndValidity();
      this.formContact.get('country')?.setValue('BRASIL');
      this.formContact.get('country')?.enable();
      this.formContact.get('country')?.updateValueAndValidity();
    }
  }
  // formContact: FormGroup = new FormGroup({        
  //   state: new FormControl(null, [Validators.required])
  // });
  cancelarSolicitacao() {
    Swal.fire({
      title: "Deseja cancelar sua Solicitação?",
      text: "Sua solicitação no momento está como pendente, ainda é possível solicitar o cancelamento da solicitação.",
      showDenyButton: true,
      confirmButtonColor: '#1A428A',
      confirmButtonText: "Continuar",
      denyButtonText: `Cancelar`
    }).then(
      (result) => {
        if (result.isConfirmed) {
          this.beneficioService.deleteCancelar(this.base.lastSolicitationId).subscribe({
            next: (res: any) => {
              Swal.fire({
                title: "Cancelamento solicitado com sucesso",
                text: "",
                timer: 1500
              }).finally(
                () => {
                  location.reload();
                }
              )
            },
            error: (err: any) => {
            }
          })
        } else if (result.isDenied) {
        }
      })
  }
  removeNullFields(obj: any) {
    for (let key in obj) {
      if (obj[key] === null) {
        delete obj[key];
      }
    }
    return obj;
  }
  salvar() {
    let files: any = [];
    let timerInterval;
    // Swal.fire({
    //   title: "Auto close alert!",
    //   html: "I will close in <b></b> milliseconds.",
    //   timer: 2000,
    //   timerProgressBar: true,
    // })
    let enderecosAlterados =
      [{
        replicateDependant: (this.formContact.get('replicateDependant')?.dirty && this.formContact.get('replicateDependant')?.value == true) ? JSON.stringify(this.formContact.get('replicateDependant')?.value) : null,
        address: this.formContact.get('cep')?.dirty ? this.formContact.get('address')?.value : null,
        cep: this.formContact.get('cep')?.dirty ? this.formContact.get('cep')?.value : null,
        city: (this.formContact.get('city')?.dirty || this.formContact.get('cep')?.dirty) ? this.formContact.get('city')?.value : null,
        comercialPhone: this.formContact.get('comercialPhone')?.dirty ? this.formContact.get('comercialPhone')?.value : null,
        complement: this.formContact.get('complement')?.dirty ? this.formContact.get('complement')?.value : null,
        country: (this.formContact.get('country')?.dirty || this.formContact.get('cep')?.dirty) ? this.formContact.get('country')?.value : null,
        district: (this.formContact.get('district')?.dirty || this.formContact.get('cep')?.dirty) ? this.formContact.get('district')?.value : null,
        email: this.formContact.get('email')?.dirty ? this.formContact.get('email')?.value : null,
        number: this.formContact.get('number')?.dirty ? this.formContact.get('number')?.value : null,
        personalPhone: this.formContact.get('personalPhone')?.dirty ? this.formContact.get('personalPhone')?.value : null,
        postalCode: this.formContact.get('postalCode')?.dirty ? this.formContact.get('postalCode')?.value : null,
        registration: this.formContact.get('registration')?.dirty ? this.formContact.get('registration')?.value : null,
        secondaryEmail: this.formContact.get('secondaryEmail')?.dirty ? this.formContact.get('secondaryEmail')?.value : null,
        state: (this.formContact.get('state')?.dirty || this.formContact.get('cep')?.dirty) ? this.formContact.get('state')?.value : null,
      }];
    let documentosBancarios = this.listaDocumentos;
    let documentoBsa = this.formDocumentos.get('documentoBsa.file')?.value as any;
    let documentoRg = this.formDocumentos.get('documentoRg.file')?.value as any;
    let documentoRescisao = this.formDocumentos.get('documentoRescisao.file')?.value as any;
    let documentoCpf = this.formDocumentos.get('documentoCpf.file')?.value as any;
    if (documentosBancarios != null) {
      documentosBancarios.forEach((element: any) => {
        files.push({ typeFile: 'dados_bancarios', contentType: element.contentType, file: element.file, fileName: element.fileName });
      });
    }
    if (documentoRg != null) {
      documentoRg.forEach((element: any) => {
        files.push({ typeFile: 'rg', contentType: element.contentType, file: element.file, fileName: element.fileName });
      });
    }
    if (documentoCpf != null) {
      documentoCpf.forEach((element: any) => {
        files.push({ typeFile: 'cpf', contentType: element.contentType, file: element.file, fileName: element.fileName });
      });
    }
    if (documentoRescisao != null) {
      documentoRescisao.forEach((element: any) => {
        files.push({ typeFile: 'rescisao', contentType: element.contentType, file: element.file, fileName: element.fileName });
      });
    }
    if (documentoBsa != null) {
      documentoBsa.forEach((element: any) => {
        files.push({ typeFile: 'bsa', contentType: element.contentType, file: element.file, fileName: element.fileName });
      });
    }
    let beneficio = {
      acceptedTerms: this.aceiteFinalizar,
      agencia: this.dataBanco?.agencia,
      benefitTypeId: this.formInstituido.get('instituido')?.value,
      conta: this.dataBanco?.conta,
      dependentes: [],
      files: null,
      pdvAgendado: [
        {
          actualHealth: (this.user && this.user.healthProfile) ? this.user.healthProfile.description : null,
          actualSocialSecurity: (this.user && this.user.socialSecurityProfile) ? this.user.socialSecurityProfile.description : null,
          adicionalBeneficio: this.formDocumentos.get('adicionalBeneficio')?.value,
          // contribuicaoeOuAportes: this.formDocumentos.get('contribuicaoeOuAportes')?.value,
          contribuicaoNormalMensal: (this.formDocumentos.get('contribuicaoNormalMensal')?.value == null) ? 0 : this.formDocumentos.get('contribuicaoNormalMensal')?.value,
          id: (this.formDocumentos.get('id')?.value == null) ? 0 : this.formDocumentos.get('id')?.value,
          interessePermanencia: this.formDocumentos.get('interessePermanencia')?.value,
          portabilidadeOuResgateParcial: this.formDocumentos.get('portabilidadeOuResgateParcial')?.value,
          quantidadeParcelas: (this.formDocumentos.get('quantidadeParcelas')?.value == null) ? 0 : this.formDocumentos.get('quantidadeParcelas')?.value,
          solicitationId: (this.formDocumentos.get('solicitationId')?.value == null) ? 0 : this.formDocumentos.get('solicitationId')?.value,
          tributacao: this.formDocumentos.get('tributacao')?.value,
          valorSolicitadoPortabilidadeParcial: this.formDocumentos.get('valorSolicitadoPortabilidadeParcial')?.value == null ? 0 : this.formDocumentos.get('valorSolicitadoPortabilidadeParcial')?.value,
        }
      ],
      planId: this.planId, // Para que serve isso?
      requestPerson: [{
      }]
    };
    if (this.listaDependentesIr.length > 0) {
      let lista = beneficio.dependentes as any;
      this.listaDependentesIr.forEach((item: any) => {
        lista.push({ nome: item.name, cpf_Dependente: item.cpf, dependencia: item.familyType, cpf: this.base.pessoa.cpf, empresa: this.base.titulares.empresa });
      }
      )
    }
    beneficio.requestPerson = enderecosAlterados.map(this.removeNullFields);
    // this.removeNullFields(enderecosAlterados);
    beneficio.files = files;
    if (Object.keys(beneficio.requestPerson[0]).length === 0) {
      beneficio.requestPerson = [];
    }
    // beneficio.requestPerson = (beneficio.requestPerson[0] == null) ? null : verificaNull;    
    setTimeout(() => {
      Swal.fire({
        title: "Finalizar a solicitação?",
        text: "Sua solicitação será encaminhada para análise.",
        showDenyButton: true,
        confirmButtonColor: '#1A428A',
        confirmButtonText: "Finalizar",
        denyButtonText: `Cancelar`
      }).then((result) => {
        if (result.isConfirmed) {
          this.formFinalizado = true;
          this.loadingCosts = true;
          this.beneficioService.postSalvarBeneficio(JSON.stringify(beneficio)).subscribe({
            next: (res: any) => {
              Swal.fire({
                title: 'Solicitação realizada com sucesso!',
                text: 'Foi encaminhado na sua caixa de e-mail um comprovante...',
                icon: 'success',
                showConfirmButton: false,
                timer: 5000
              }).then(
                () => {
                  //  this.loadAfterRequired = true;
                  this.loadingCosts = false;
                  this.router.navigate(['/minhas-solicitacoes-pdv']);
                }
              )
            },
            error: (err: any) => {
              Swal.fire({
                title: 'Oooops...!',
                text: 'Ocorreu um erro!',
                icon: 'error',
                showConfirmButton: false,
                timer: 5000
              })
              this.loadingCosts = false;
            }
          })
        } else if (result.isDenied) {
        }
      });
    }, 200)
  }
  initComboBox() {
    for (let i = 2; i < 13; i++) {
      this.listaValores.push({ value: i, label: i });
    }
  }
  removeFile(index: number) {
    this.listaDocumentos.splice(index, 1);
    // const lista: any = this.formDadosBancarios.get(`documentos.file`)?.value;
    // lista.splice(index, 1);
    // this.formDadosBancarios.get(`documentos.file`)?.updateValueAndValidity();
    // this.listaDocumentos.splice(index, 1);
  }
  peculio() {
    // let actualUser = this.tokenService.getActiveUser();
    // this.possuiPeculio = (this.base?.plano?.peculioCobertura != 0) ? true : false;
  }
  redirecionar() {
  }
  adicionarDependenteIr(dependente: any) {
    if (this.listaDependentesIr.indexOf(dependente) == -1) {
      this.listaDependentesIr.push(dependente);
    } else if (this.listaDependentesIr.indexOf(dependente) !== -1) {
      let index = this.listaDependentesIr.indexOf(dependente);
      if (index !== -1) {
        this.listaDependentesIr.splice(index, 1);
      }
    }
  }
  modalFinalizacao() {
    const modalRef = this.modalService.open(ModalValidacaoPlanoSaudeInstitutoComponent, { size: 'lg', centered: true });
  }
  alterarDadosBancarios() {
    const modalRef = this.modalService.open(ModalDadosBancariosPDVComponent, { size: 'lg', centered: true });
    // modalRef.componentInstance.lista = (this.formDadosBancarios.get('documentos.file')?.value != null) ? this.formDadosBancarios.get('documentos.file')?.value: null;
    modalRef.componentInstance.lista = this.listaDocumentos;
    modalRef.result.then((result) => {
      if (result) {
        this.listaDocumentos = result;
        // this.formDadosBancarios.controls.documentos = this.createDocument(true);
        // this.formDadosBancarios.get('documentos.file')?.setValue(result);
        // Faça algo com a lista retornada
      }
    }).catch((error) => {
    });
    // if(this.listaDocumentos!= null && this.listaDocumentos.length > 0){
    //   this.formDadosBancarios.controls.documentos = this.createDocument(true);
    //   this.formDadosBancarios.get('documentos.file')?.setValue(this.listaDocumentos);
    // }
  }
  redirectTo(id: string) {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  }
  mostrarValores() {
  }
  resetInstituto() {
    this.formDocumentos.reset();
    this.clearAllValidators();
  }
  onStepChange(event: any) {
    let element = null;
    switch (event.selectedIndex) {
      case 0:
        this.formContact.updateValueAndValidity();
        element = document.getElementById('dados-pessoais');
        break;
      case 1:
        element = document.getElementById('dados-bancarios');
        break;
      case 2:
        element = document.getElementById('dependentes-ir');
        break;
      case 3:
        element = document.getElementById('instituto');
        break;
      case 4:
        this.addValidators();
        element = document.getElementById('formularioInstituto');
        break;
      case 5:
        if (this.user.healthProfile && this.user.healthProfile?.description) {
          element = document.getElementById('saude');
          const modalRef = this.modalService.open(ModalValidacaoPlanoSaudeInstitutoComponent, { size: 'lg', centered: true, keyboard: false, backdrop: 'static' });
        }
        break;
      case 6:
        element = document.getElementById('finalizacao');
        break;
    }
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      element == null;
    }
  }
  clearAllValidators() {
    Object.keys(this.formDocumentos.controls).forEach(controlName => {
      const control = this.formDocumentos.get(controlName);
      if (control) {
        control.clearValidators();
        control.updateValueAndValidity();
      }
    });
    this.formDocumentos.controls.documentoRg = this.createDocument(false);
    this.formDocumentos.controls.documentoCpf = this.createDocument(false);
    this.formDocumentos.controls.documentoRescisao = this.createDocument(false);
    this.formDocumentos.controls.documentoBsa = this.createDocument(false);
  }
  createDocument(enabled: boolean, nome?: string) {
    return this._formBuilder.group({
      name: new FormControl({ value: nome, disabled: !enabled }),
      file: new FormControl({ value: null, disabled: !enabled }, [Validators.required]),
      fileName: new FormControl({ value: null, disabled: !enabled }),
      MD5: new FormControl({ value: null, disabled: !enabled }),
    })
  }
  adicionarArquivos(documentName: string, event: any): void {
    switch (documentName) {
      case 'documentoRg':
        this.formDocumentos.get(`documentoRg.file`)?.setValue(event);
        this.formDocumentos.updateValueAndValidity();
        break;
      case 'documentoCpf':
        this.formDocumentos.get(`documentoCpf.file`)?.setValue(event);
        this.formDocumentos.updateValueAndValidity();
        break;
      case 'documentoRescisao':
        this.formDocumentos.get(`documentoRescisao.file`)?.setValue(event);
        this.formDocumentos.updateValueAndValidity();
        break;
      case 'documentoBsa':
        this.formDocumentos.get(`documentoBsa.file`)?.setValue(event);
        this.formDocumentos.updateValueAndValidity();
        break;
    }
    // setTimeout(
    //   () => {
    //   }, 200
    // )
  }
  removeFileDocument(documentName: string, position: any) {
    const lista: any = this.formDocumentos.get(`${documentName}.file`)?.value;
    lista.splice(position, 1);
    this.formDocumentos.get(`${documentName}.file`)?.updateValueAndValidity();
  }
  adicionarRisco(valor: number) {
    let ben = this.taxaAdministrativa;
    let benTax = this.beneficioRisco + this.taxaAdministrativa;
    if (valor == 1) {
      this.formDocumentos.get('contribuicaoNormalMensal')?.reset();
      this.formDocumentos.get('contribuicaoNormalMensal')?.setValidators([FormValidator.validValor(parseFloat(parseFloat(this.mediaSalarial).toFixed(2)))]),
        this.formDocumentos.get('contribuicaoNormalMensal')?.updateValueAndValidity();
    } else {
      this.formDocumentos.get('contribuicaoNormalMensal')?.reset();
      this.formDocumentos.get('contribuicaoNormalMensal')?.setValidators([FormValidator.validValor(parseFloat(parseFloat(this.mediaSalarial).toFixed(2)))]),
        this.formDocumentos.get('contribuicaoNormalMensal')?.updateValueAndValidity();
    }
  }
  addValidators() {
    switch (this.formInstituido.get('instituido')?.value) {
      case '1':
        this.formDocumentos.get('tributacao')?.setValidators([Validators.required]);
        this.formDocumentos.get('aceite')?.setValidators([Validators.required]);
        this.formDocumentos.get('tributacao')?.updateValueAndValidity();
        this.formDocumentos.get('aceite')?.updateValueAndValidity();
        this.formDocumentos.controls.documentoRg = this.createDocument(true);
        this.formDocumentos.controls.documentoCpf = this.createDocument(true);
        this.formDocumentos.controls.documentoRescisao = this.createDocument(true);
        if (this.profile && this.profile?.hasBsaPermission) {
          this.formDocumentos.controls.documentoBsa = this.createDocument(true);
        }
        // documentoCpf: this.createDocument(false),
        // documentoRecisao: this.createDocument(false),
        // documentoBsa: this.createDocument(false),
        break;
      case '10':
        this.formDocumentos.get('adicionalBeneficio')?.setValidators([Validators.required]);
        this.formDocumentos.get('aceite')?.setValidators([Validators.required]);
        this.formDocumentos.get('adicionalBeneficio')?.updateValueAndValidity();
        this.formDocumentos.get('aceite')?.updateValueAndValidity();
        if (this.possuiPeculio) {
          this.formDocumentos.get('interessePermanencia')?.setValidators([Validators.required]);
          this.formDocumentos.get('interessePermanencia')?.updateValueAndValidity();
        }
        break;
      case '11':
        this.formDocumentos.get('adicionalBeneficio')?.setValidators([Validators.required]);
        this.formDocumentos.get('aceite')?.setValidators([Validators.required]);
        this.formDocumentos.get('adicionalBeneficio')?.updateValueAndValidity();
        this.formDocumentos.get('aceite')?.updateValueAndValidity();
        if (this.possuiPeculio) {
          this.formDocumentos.get('interessePermanencia')?.setValidators([Validators.required]);
          this.formDocumentos.get('interessePermanencia')?.updateValueAndValidity();
        }
        break;
      case '12':
        this.formDocumentos.get('aceite')?.setValidators([Validators.required]);
        this.formDocumentos.get('aceite')?.updateValueAndValidity();
        break;
      case '13':
        let valor = this.ContributionHistory + this.AdditionalContribution;
        this.formDocumentos.get('valorSolicitadoPortabilidadeParcial')?.setValidators([Validators.required, FormValidator.valorMaximo(valor)]);
        // this.formDocumentos.get('portabilidadeOuResgateParcial')?.setValidators([Validators.required]);
        this.formDocumentos.get('portabilidadeOuResgateParcial')?.setValue('FacultativasEOuAportes');
        this.formDocumentos.get('aceite')?.setValidators([Validators.required]);
        this.formDocumentos.get('valorSolicitadoPortabilidadeParcial')?.updateValueAndValidity();
        // this.formDocumentos.get('portabilidadeOuResgateParcial')?.updateValueAndValidity();            
        this.formDocumentos.get('aceite')?.updateValueAndValidity();
        break;
      case '14':
        this.formDocumentos.get('quantidadeParcelas')?.setValidators([Validators.required]);
        this.formDocumentos.get('tributacao')?.setValidators([Validators.required]);
        this.formDocumentos.get('aceite')?.setValidators([Validators.required]);
        this.formDocumentos.get('quantidadeParcelas')?.updateValueAndValidity();
        this.formDocumentos.get('tributacao')?.updateValueAndValidity();
        this.formDocumentos.get('aceite')?.updateValueAndValidity();
        break;
      case '15':
        // this.formDocumentos.get('portabilidadeOuResgateParcial')?.setValidators([Validators.required]);
        this.formDocumentos.get('valorSolicitadoPortabilidadeParcial')?.setValidators([Validators.required, FormValidator.valorMaximo(this.ContributionHistory + this.AdditionalContribution)]);
        this.formDocumentos.get('portabilidadeOuResgateParcial')?.setValue('FacultativasEOuAportes');
        this.formDocumentos.get('tributacao')?.setValidators([Validators.required]);
        this.formDocumentos.get('aceite')?.setValidators([Validators.required]);
        this.formDocumentos.get('valorSolicitadoPortabilidadeParcial')?.updateValueAndValidity();
        this.formDocumentos.get('portabilidadeOuResgateParcial')?.updateValueAndValidity();
        this.formDocumentos.get('tributacao')?.updateValueAndValidity();
        this.formDocumentos.get('aceite')?.updateValueAndValidity();
        break;
      case '16':
        this.formDocumentos.get('aceite')?.setValidators([Validators.required]);
        this.formDocumentos.get('tributacao')?.setValidators([Validators.required]);
        this.formDocumentos.get('tributacao')?.updateValueAndValidity();
        this.formDocumentos.get('aceite')?.updateValueAndValidity();
        if (this.formDocumentos.controls.documentoRg.value.file == null && this.formDocumentos.controls.documentoCpf.value.file == null) {
          this.formDocumentos.controls.documentoRg = this.createDocument(true);
          this.formDocumentos.controls.documentoCpf = this.createDocument(true);
          this.formDocumentos.updateValueAndValidity();
        }
        break;
    }
  }
  ngOnInit(): void {
  }
  ngAfterViewInit(): void {
    this.peculio();
  }
  checkFormularioAlterado(): boolean {
    for (const key in this.initialValueForm) {
      if (this.initialValueForm[key] != this.formContact.getRawValue()[key]) {
        if (this.initialValueForm[key] == null && this.formContact.getRawValue()[key] == "") {
          return false;
        }
        return true;
      }
    }
    return false;
  }
  @HostListener('input', ['$event'])
  onInputChange(event: Event) {
    this.formChanged = this.checkFormularioAlterado();
  }
  // @HostListener('document:click', ['$event'])
  // onClick(event: Event) {
  //   const clickedInside = this.containerSelect.nativeElement.contains(event.target);
  //   if (!clickedInside) {
  //     this.resetValor('parcelado');
  //   }
  // }
}
